import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=9b99729a&scoped=true"
import script from "./FirstPage.vue?vue&type=script&lang=js"
export * from "./FirstPage.vue?vue&type=script&lang=js"
import style0 from "./FirstPage.vue?vue&type=style&index=0&id=9b99729a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b99729a",
  null
  
)

export default component.exports